import React from 'react';
import styled from 'styled-components';

interface StatusChipProps {
  status: string;
  children: React.ReactNode;
  className?: string;
}

const StatusChip: React.FC<StatusChipProps> = ({ status, children, className }) => {
  return (
    <StyledStatusChip status={status} className={className}>
      {children}
    </StyledStatusChip>
  );
};

const StyledStatusChip = styled.div<{ status: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  text-transform: capitalize;
  white-space: nowrap;
  
  background-color: ${({ theme, status }) => {
    switch (status?.toUpperCase()) {
      case 'DRAFT':
        return theme.palette.colors.statusDraftBg;
      case 'SCHEDULED':
        return theme.palette.info.light;
      case 'ACTIVE':
      case 'PUBLISHED':
        return theme.palette.colors.statusActiveBg;
      case 'RETIRED':
      case 'ARCHIVED':
        return theme.palette.colors.statusRetiredBg;
      default:
        return theme.palette.colors.statusDraftBg;
    }
  }};
  
  color: ${({ theme, status }) => {
    switch (status?.toUpperCase()) {
      case 'DRAFT':
        return theme.palette.colors.statusDraft;
      case 'SCHEDULED':
        return theme.palette.info.main;
      case 'ACTIVE':
      case 'PUBLISHED':
        return theme.palette.colors.statusActive;
      case 'RETIRED':
      case 'ARCHIVED':
        return theme.palette.colors.statusRetired;
      default:
        return theme.palette.colors.statusDraft;
    }
  }};
`;

export default StatusChip;